exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gantt-grid .vxe-table--header-wrapper .vxe-header--column {\n  height: 60px;\n}\n.gantt-grid .vxe-table .vxe-body--column {\n  height: 36px;\n  line-height: 36px;\n  padding: 0;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#e8eaec), to(#e8eaec));\n  background-image: linear-gradient(#e8eaec, #e8eaec);\n  cursor: pointer;\n}\n.gantt-grid .vxe-table .vxe-body--column::after {\n  content: '';\n  bottom: 0;\n  position: absolute;\n}\n", ""]);

// exports
